import { render, staticRenderFns } from "./labeldialog.vue?vue&type=template&id=2418829e&scoped=true&"
import script from "./labeldialog.vue?vue&type=script&lang=js&"
export * from "./labeldialog.vue?vue&type=script&lang=js&"
import style0 from "./labeldialog.vue?vue&type=style&index=0&id=2418829e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418829e",
  null
  
)

export default component.exports